import { render, staticRenderFns } from "./StationResearchResult.vue?vue&type=template&id=6506261a&scoped=true&"
import script from "./StationResearchResult.vue?vue&type=script&lang=js&"
export * from "./StationResearchResult.vue?vue&type=script&lang=js&"
import style0 from "./StationResearchResult.vue?vue&type=style&index=0&id=6506261a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506261a",
  null
  
)

export default component.exports